import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Link, Checkbox, useBreakpoints, StackInline } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_URL_PREFIX } from '../../../constants/ProductConstants';
import compareActions from '../../../redux/compare/actions/CompareActions.creators';
import { makeGetCompareItems } from '../../../redux/compare/selectors/CompareSelectors';
import { makeGetProductCompareInformation, makeGetIsCompareProduct, makeGetSelectedSku, } from '../../../redux/product/selectors/ProductSelector';
export const ProductCompareSelector = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { brand, seoUrl, colorId, productId, productCode, title, image, colorDescription, sizes, gender, buyingGroup, productQualifier, brandValue, } = useSelector(makeGetProductCompareInformation());
    const isCompareProduct = useSelector(makeGetIsCompareProduct());
    const selectedSku = useSelector(makeGetSelectedSku());
    const compareItems = useSelector(makeGetCompareItems());
    const { isXs, isSm } = useBreakpoints();
    const dispatch = useDispatch();
    const { rootWithLanguageSuffix, root } = useAemConfig();
    const isMobile = isXs || isSm;
    const selectedSize = sizes === null || sizes === void 0 ? void 0 : sizes.find((size) => size.sku === selectedSku);
    const compareProduct = {
        id: productId,
        color: colorId,
        url: `${rootWithLanguageSuffix}/${PRODUCT_URL_PREFIX}${seoUrl.indexOf('/') === 0 ? '' : '/'}${seoUrl}.html?colour${colorId}`,
        title,
        brand,
        image,
        productCode,
        selected: false,
        colorDescription,
        size: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize) !== '.' ? selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize : undefined,
        collapsedComparePopup: true,
        gender,
        buyingGroup,
        productQualifier,
        brandValue,
    };
    const showLinkToComparePage = isMobile && isCompareProduct && (compareItems === null || compareItems === void 0 ? void 0 : compareItems.length) > 1;
    const handleChange = () => {
        dispatch(compareActions.createUpdateOnProductDetailPageAction(compareProduct));
    };
    return (_jsxs(StackInline, { gap: "2", itemsAlign: "center", children: [_jsx(Checkbox, { testId: "product_compare_checkbox", id: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, name: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, value: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, checked: isCompareProduct, onChange: handleChange, label: showLinkToComparePage ? undefined : t('product:productCompare.pdp.checkbox') }), showLinkToComparePage && (_jsx(Link, { testId: "product_compare_link", variant: "primary", theme: "neutral", iconRight: { source: CaretRightIcon, size: 'xs' }, href: `${root}products/product-compare.html`, children: t('productCompare.pdp.checkbox') }))] }));
};
